export default "<p>\r\n  creacion-paquete works!\r\n</p>\r\n"